<template>
  <div>
    <slot></slot>
    <div v-if="formerror.fieldErrors && formerror.fieldErrors[name]" class="form-control-feedback">{{formerror.fieldErrors[name]}}</div>
  </div>
</template>

<script>

export default {
  name: 'InputValidation',
  props: ['formerror', 'name'],
}
</script>
